import type { SavedAction } from "./actionTypes"

interface SavedActionConfirmationCopy {
    title: string
    description: string
    buttonText: string
}

const ABANDON_DESCRIPTION =
    "This preserves task-owned changes in local commits, cleans up task-owned worktrees including review snapshots, and closes without integrating or pushing. Branches, commits, and checkouts needed by active sessions or follow-ups remain."
const GENERIC_DESCRIPTION = "This Action may make destructive or difficult-to-reverse changes."
const DRAFT_DESCRIPTION = "Your current draft will be included as additional instructions."

export function savedActionConfirmationCopy(action: Pick<SavedAction, "name" | "source">, hasDraftableContent: boolean): SavedActionConfirmationCopy {
    const isAbandon = action.source?.templateId === "abandon"
    const description = isAbandon ? ABANDON_DESCRIPTION : GENERIC_DESCRIPTION
    return {
        title: isAbandon ? "Abandon this task?" : `Run ${action.name}?`,
        description: hasDraftableContent ? `${description} ${DRAFT_DESCRIPTION}` : description,
        buttonText: isAbandon ? "Abandon task" : `Run ${action.name}`,
    }
}
